// extracted by mini-css-extract-plugin
export var container_img = "relatedProductsDetail-module--container_img--29ddc";
export var ourRecipes__container = "relatedProductsDetail-module--ourRecipes__container--eeb24";
export var ourRecipes__item = "relatedProductsDetail-module--ourRecipes__item--62d87";
export var ourRecipes__variants = "relatedProductsDetail-module--ourRecipes__variants--68678";
export var relatedProductsDetail = "relatedProductsDetail-module--relatedProductsDetail--bcc20";
export var relatedProductsDetailContainer = "relatedProductsDetail-module--relatedProductsDetailContainer--9e6df";